import { StandardEvents } from '@shopify/events';
// Savor owns requests and cart updates. This element only adds local UI state
// and resolves explicit variant changes through Shopify section rendering.
class FDProductPurchase extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.dataset.state = "idle";
    this.querySelector("[ref=addToCartButton]")?.setAttribute("data-puppet", "true");
    this.querySelector('[data-variant-select]')?.addEventListener('change', (event) => this.selectVariant(event.target.value), options);
    this.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
      if (event.action !== 'add' || !this.contains(event.target)) return;
      this.setPending(true);
      event.promise?.then(({ detail }) => {
        this.dataset.state = detail?.didError ? "error" : "success";
        this.status(detail?.didError ? this.dataset.error : this.dataset.added);
      }).catch(() => { this.dataset.state = "error"; this.status(this.dataset.error); }).finally(() => this.setPending(false));
    }, options);
    this.addEventListener(StandardEvents.cartError, () => { this.dataset.state = "error"; this.status(this.dataset.error); }, options);
    this.addEventListener('submit', (event) => {
      if (this.pending || this.dataset.saleBlocked === 'true') { event.preventDefault(); event.stopImmediatePropagation(); if (this.dataset.saleBlocked === 'true') this.status(this.dataset.unavailable); }
    }, { ...options, capture: true });
  }
  status(text) { this.querySelector('[data-purchase-status]').textContent = text; }
  setPending(pending) {
    this.pending = pending; this.setAttribute('aria-busy', String(pending));
    this.querySelectorAll('button[type="submit"], [data-variant-select]').forEach((control) => {
      if (pending) { control.dataset.fdDisabled = String(control.disabled); control.disabled = true; }
      else control.disabled = control.dataset.fdDisabled === 'true';
    });
    if (pending) { this.dataset.state = "pending"; this.status(this.dataset.pending); }
  }
  async selectVariant(id) {
    this.request?.abort(); this.request = new AbortController(); this.setPending(true);
    const url = new URL(this.dataset.url, location.origin); url.searchParams.set('variant', id); url.searchParams.set('section_id', this.dataset.sectionId);
    try {
      const response = await fetch(url, { signal: this.request.signal });
      if (!response.ok) throw new Error('Variant unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacement = html.querySelector('fd-product-purchase');
      if (!replacement || replacement.querySelector('[name="id"]')?.value !== id) throw new Error('Variant mismatch');
      const page = new URL(location.href); page.searchParams.set('variant', id); history.replaceState({}, '', page);
      this.replaceWith(replacement);
      replacement.querySelector('[data-variant-select]')?.focus();
    } catch (error) {
      if (error.name !== 'AbortError') { this.status(this.dataset.error); this.setPending(false); const picker = this.querySelector('[data-variant-select]'); if (picker) picker.value = this.querySelector('[name="id"]').value; }
    }
  }
  disconnectedCallback() { this.abort?.abort(); this.request?.abort(); }
}
if (!customElements.get('fd-product-purchase')) customElements.define('fd-product-purchase', FDProductPurchase);

class FDShare extends HTMLElement {
 connectedCallback() {
  this.abort?.abort(); this.abort = new AbortController(); const options = { signal: this.abort.signal };
  const native = this.querySelector('[data-native-share]'); if (navigator.share) native.hidden = false;
  this.addEventListener('click', async event => {
   const status = this.querySelector('[data-share-status]');
   if (event.target.closest('[data-copy-link]')) {
    try { await navigator.clipboard.writeText(this.dataset.url); status.textContent = this.dataset.copied; }
    catch {
     const input = this.querySelector('[data-share-fallback]'); input.hidden = false; input.focus(); input.select();
     let copied = false; try { copied = document.execCommand('copy'); } catch { /* Manual selection remains available. */ }
     status.textContent = copied ? this.dataset.copied : this.dataset.copyFailed;
     if (copied) { input.hidden = true; this.querySelector('[data-copy-link]').focus(); }
    }
   }
   if (event.target.closest('[data-native-share]') && navigator.share) {
    try { await navigator.share({ title: this.dataset.title, url: this.dataset.url }); }
    catch (error) { if (error.name !== 'AbortError') status.textContent = this.dataset.shareFailed; }
   }
  }, options);
  this.addEventListener('keydown', event => { if (event.key === 'Escape') { const details = this.querySelector('details'); details.open = false; details.querySelector('summary').focus(); } }, options);
 }
 disconnectedCallback() { this.abort?.abort(); }
}
if (!customElements.get('fd-share')) customElements.define('fd-share', FDShare);
